import React from 'react';
import CEO from './assets/leadership/JudithBlay.jpg';

const CeoMessage = () => {
  return (
    <div className="flex flex-col md:flex-row h-18 py-10 4K-screen:py-40">
      
      {/* Image Section */}
      <div className="relative flex-1 overflow-hidden">
        <img
          src={CEO}
          alt="CEO"
          className="w-full h-full object-cover"
        />
        {/*  */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#001A3A]/0 to-[#001A3A]" />
      </div>

      {/* Text Section */}
      <div className="flex-1 bg-[#001A3A] text-white flex flex-col justify-center p-10">
        <h1 className="text-4xl text-orange-500 font-fjalla mb-6">
        Ms Judith Adjobah Blay
        </h1>

        <h2 className="text-2xl font-light">
         Chief Executive Officer
        </h2>
      </div>

    </div>
  );
};

export default CeoMessage;
